import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

// import utils from General HTML Support plugin
import {
  getHtmlAttributeName,
  modifyGhsAttribute,
  setViewAttributes,
} from '@ckeditor/ckeditor5-html-support/src/utils';

export default class CustomHeadings extends Plugin {
  afterInit() {
    const editor = this.editor;
    const conversion = editor.conversion;

    // Get config of custom heading options
    const customHeadingOptions = editor.config.get('customHeadingOptions');

    this._setupCustomHeadingsConversion(conversion, customHeadingOptions);
  }

  _setupCustomHeadingsConversion(conversion, headingOptions) {
    if (headingOptions) {
      headingOptions.forEach((heading) => {
        // Add downcast conversion (from model to view) on insert to each heading option
        conversion.for('downcast').add((dispatcher) => {
          dispatcher.on(
            `insert:${heading.model}`,
            (evt, data, conversionApi) => {
              const { writer } = conversionApi;
              const modelElement = data.item;
              const GHSAttributesName = getHtmlAttributeName(heading?.view);
              const isClassesArray = Array.isArray(heading.classes);

              if (GHSAttributesName) {
                // Add class to classes attribute (at htmlAttributes) in model layer
                modifyGhsAttribute(
                  writer,
                  modelElement,
                  GHSAttributesName,
                  'classes',
                  (classSet) => {
                    // console.log('add class');
                    if (isClassesArray) {
                      heading.classes.forEach((className) =>
                        classSet.add(className)
                      );
                    } else classSet.add(heading.classes);
                  }
                );

                setViewAttributes(
                  writer,
                  {
                    classes: isClassesArray
                      ? [...heading.classes]
                      : heading.classes,
                  },
                  conversionApi.mapper.toViewElement(modelElement)
                );
              }
            }
          );
        });
      });
    }
  }
}
